export default class ZipCodeService {

  static fetch(zipCode) {

    const url = `https://viacep.com.br/ws/${zipCode}/json`

    return fetch(url).then((response) => response.json())
  }
}